import { render, staticRenderFns } from "./DeclarationsStatistics.vue?vue&type=template&id=fbeb83a6&scoped=true&"
import script from "./DeclarationsStatistics.vue?vue&type=script&lang=js&"
export * from "./DeclarationsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbeb83a6",
  null
  
)

export default component.exports